
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/quickEditEngine/components/styles/quickEditCompPanelWrapper.scss.css.virtualfile';
        module.exports = {"quickEditCompPanelWrapper":"_quickEditCompPanelWrapper_123mk_1","fullHeight":"_fullHeight_123mk_18"};